export enum CrmEntityTypeEnum {
  None = 0,
  Contact = 1,
  MarketingList = 2,
  User = 3,
  EmailSend = 4,
  SentEmail = 5,
  Workflow = 8,
  Team = 9,
  Campaign = 10,
  EmailEvent = 11,
  WebForm = 27,
  EmailCName = 30,
  EmailTemplate = 100,
  Lead = 102,
  Account = 103,
  Currency = 104,
  OutsourcedVendor = 105,
  Event = 110,
  EventParticipation = 111,
  ContactAttributes = 120,
  LeadAttributes = 121,
  FormCapture = 200,
  SubscriptionForm = 201,
  SurveyForm = 202,
  FormField = 203,
  Domain = 204,
  SurveyQuestion = 205,
  SubscriptionList = 206
}

export enum CrmEntityLookupKnownSubType {
  Form  = 'form',
  Survey = 'survey',
  Subscription = 'subscription'
}

export enum CrmEntityLogicalNameEnum {
  contact = 1,
  list = 2,
  systemuser = 3,
  cdi_emailsend = 4,
  workflow = 8,
  team = 9,
  campaign = 10,
  cdi_webcontent = 27,
  cdi_emailtemplate = 100,
  lead = 102,
  account = 103,
  transactioncurrency = 104,
  cdi_event = 110,
  cdi_eventparticipation = 111,
  cdi_formcapture = 200,
  cdi_emailcname = 30
}

export interface ICrmEntityAttributeTypeToLookupEntityTypes {
  [attributeType: string]: CrmEntityTypeEnum[];
}

export class CrmEntity {
  attributes: CrmEntityAttribute[] = [];
  entityType: CrmEntityTypeEnum;
  entityName: string;
  entityPluralLabel: string;
}

export type CrmEntityAttributeTypeEnum =
  'Boolean' | 'List' | 'TextArea' | 'Text' | 'Decimal' |
  'Integer' | 'Money' | 'DateTime' | 'DateOnly' | 'DateTimeZoneIndependent' | 'Lookup';

export interface IAttributeOption {
  text: string;
  value: string;
}

export class CrmEntityAttribute {
  type: CrmEntityAttributeTypeEnum;

  logicalName: string;
  accuracy: number;
  fullNameMode: boolean;
  name: string; //the way it should appear on the UI (should be already translated)
  lookupEntityIds: any[];
  maxLength: number;
  options: IAttributeOption[];
}

